<div class="blankslate" [style.height]="height">
  <img class="mb-3" width="154" src="https://s3-sa-east-1.amazonaws.com/antecipagov.public.docs/images/no-data.svg" alt="sem dados">
  <ng-content select="[text]"></ng-content>
</div>
